import React, { useContext, useEffect, useState } from "react";
import "./RedirectRalvie.scss";
import AppContext from "../../config/AppContext";
import { ReactComponent as RalvieLogo } from "../../assets/subscription/RalvieLogo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CommonUtil from "../../util/CommonUtils";
import { paymentProcess } from "../../services/Subscription";

const RedirectRalvie = () => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const hostedpage_id = urlParams.get("hostedpage_id");
    const [activeLink,setActiveLink] =useState(false)

    useEffect(() => {
        const p_id = CommonUtil.getCookie("page_id");
        if (hostedpage_id == null || p_id != hostedpage_id) {
            navigate("/page-not-found")
        } else {
            paymentProcess(hostedpage_id).then((res) => {
            setActiveLink(true)
            })
        }
    }, [])

    setTimeout(() => {
        if (window.location.pathname == "/redirect-ralvie")
            navigate("/subscription-me")
    }, 10000);

    return (
        <div className="Redirect-loading">
            <div className="ralvielogo-align">
                <RalvieLogo />
            </div>
            <div className="redirectnamelabel">
                <span className={mode === "dark" ? "Redirect-textDark" : "Redirect-text"}>{t("RAL0930")}</span>
                <span className={mode === "dark" ? "Redirect-textDark" : "Redirect-text"}>{t("RAL0931")} <Link to={activeLink && "/subscription-me"} className={mode === "dark" ? "clickherelinkDark" : "clickherelink"}>{t("RAL0932")}</Link></span>
            </div>
        </div>
    );
};

export default RedirectRalvie;
